import {prefixes} from '../constants'

const getSuccessActionType = (type): string => type + prefixes.SUCCESS

const getErrorActionType = (type): string => type + prefixes.UNSUCCESS

export {getSuccessActionType, getErrorActionType}
